import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  json,
  redirect,
} from "@remix-run/node";
import { Form, useActionData } from "@remix-run/react";
import { useEffect, useState } from "react";
import { ButtonBasic } from "~/components/design/ButtonBasic";
import { getGraphqlApiBaseUrl } from "~/gql/url_helpers";
import { useRootContext } from "~/root_context";
import mySvgHref from "../components/layout_mira_clone/logo.svg";

import { getContactId } from "~/session.server";
import { FORGOT_PASSWORD_URL } from "~/known_routes";

export async function loader({ request }: LoaderFunctionArgs) {
  const contactId = await getContactId(request);
  if (contactId) return redirect("/");
  return json({});
}

export async function action({ request }: ActionFunctionArgs) {
  const formData = await request.formData();
  const email = formData.get("email");

  if (!email) {
    return redirect(FORGOT_PASSWORD_URL);
  }

  const fd = new URLSearchParams();
  fd.append("username", (email as string).trim());
  const resetResponse = await fetch(
    getGraphqlApiBaseUrl() + "/contactauth/start_reset_password",
    {
      method: "POST",
      body: fd,
    }
  );
  const resetData = await resetResponse.json();
  console.log("resetData", resetData);

  return json({ success: true });
}

export default function ForgotPasswordPage() {
  const { setBodyStyles } = useRootContext();
  const actionData = useActionData<{ success?: boolean; reason?: string }>();
  const [showError, setShowError] = useState<boolean>(
    actionData?.success === false
  );

  useEffect(() => {
    setBodyStyles("h-full");
    return () => {
      setBodyStyles("");
    };
  }, []);

  useEffect(() => {
    if (actionData?.success === false) {
      setShowError(true);
    }
  }, [actionData]);

  return (
    <div className="flex h-full">
      <div className="flex-1 bg-blue-700 h-full">
        <div className="flex flex-col items-center justify-center h-full">
          <div className="bg-white">
            <div className="text-5xl font-bold text-center mt-10 flex justify-center">
              <img src={mySvgHref} className="w-12 h-12 mr-2" />
              CPRM
            </div>
            <div className="text-2xl m-5 text-center">Instructor Portal</div>

            <div>
              {!actionData?.success && (
                <Form
                  method="post"
                  className="flex flex-col m-10 min-w-[300px]"
                >
                  <div id="form-error-message" className="mb-2">
                    {showError && actionData?.reason ? (
                      <p
                        className="text-red-500 bg-red-200 border-red-500 p-2 text-xl font-bold"
                        role="alert"
                      >
                        {actionData.reason}
                      </p>
                    ) : null}
                  </div>

                  <label htmlFor="email">Email address</label>
                  <input
                    id="email"
                    required
                    name="email"
                    type="email"
                    autoComplete="email"
                    onKeyDown={() => setShowError(false)}
                    className="border border-gray-400 rounded px-2 py-1 mb-4"
                  />

                  <ButtonBasic className="mt-4 !block text-center">
                    Send Reset Email
                  </ButtonBasic>
                </Form>
              )}

              {actionData?.success && (
                <div className="flex flex-col m-10 max-w-[300px]">
                  If your email address matches one in our records, you will
                  receive an email to proceed with your password reset.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
